import {
  Settings,
  Users,
  Mail,
  Shield,
  KeyRound,
  ScrollText,
  Key,
  UserCircle,
  Lock,
  Bell,
  Plug,
  UsersRound,
  MapPin,
  MessageSquareText,
  Tag,
  QrCode,
  Wallet,
  Zap,
  GitBranch,
  Handshake,
  FileText,
} from "lucide-react";

/**
 * Configuration sub-nav sections.
 *
 * To add a new item, just append to the relevant section's `items` array.
 * To add a new section, add a new object with `sectionLabel`, `defaultOpen`, and `items`.
 *
 * Each item:
 *   id    – unique key
 *   label – display text
 *   href  – route path (must match a route in App.jsx)
 *   icon  – lucide-react component
 */
export const CONFIGURATIONS_NAV = [
  {
    sectionLabel: "Organization",
    defaultOpen: true,
    // Callers get only account-level settings — no org-wide configuration.
    hideForRoles: ["caller"],
    items: [
      { id: "config-general", label: "General", href: "/configurations/general", icon: Settings },
      // Member / role administration is only shown to users who can manage them.
      { id: "config-members", label: "Members", href: "/configurations/members", icon: Users, requires: { resource: "memberships", action: "read" } },
      { id: "config-invitations", label: "Invitations", href: "/configurations/invitations", icon: Mail, requires: { resource: "memberships", action: "read" } },
      { id: "config-roles", label: "Roles & Permissions", href: "/configurations/roles", icon: Shield, roles: ["org_admin", "site_head", "team_lead"] },
      { id: "config-teams", label: "Teams", href: "/configurations/teams", icon: UsersRound, requires: { resource: "teams", action: "read" } },
      { id: "config-geofencing", label: "Geofencing", href: "/configurations/geofencing", icon: MapPin, requires: { resource: "attendance", action: "configure" } },
      // { id: "config-secrets", label: "Secrets", href: "/configurations/secrets", icon: KeyRound },
      { id: "config-audit-log", label: "Audit Log", href: "/configurations/audit-log", icon: ScrollText, roles: ["org_admin", "site_head", "team_lead"] },
      // { id: "config-api-keys", label: "API Keys", href: "/configurations/api-keys", icon: Key },
    ],
  },
  {
    sectionLabel: "Account",
    defaultOpen: true,
    items: [
      { id: "config-my-info", label: "My Information", href: "/configurations/my-information", icon: UserCircle },
      { id: "config-notifications", label: "Notifications", href: "/configurations/notifications", icon: Bell },
      { id: "config-reset-pw", label: "Reset Password", href: "/configurations/reset-password", icon: Lock },
    ],
  },
  {
    sectionLabel: "Core",
    defaultOpen: true,
    items: [
      { id: "config-pipelines", label: "Pipelines", href: "/configurations/pipelines", icon: GitBranch, requires: { resource: "deals", action: "read" } },
      { id: "config-integrations", label: "Integrations", href: "/configurations/integrations", icon: Plug, hideForRoles: ["caller"] },
      { id: "config-templates", label: "Templates", href: "/configurations/templates", icon: MessageSquareText, requires: { resource: "templates", action: "read" } },
      { id: "config-tags", label: "Tags", href: "/configurations/tags", icon: Tag, requires: { resource: "tags", action: "read" } },
      { id: "config-qr-codes", label: "QR Codes", href: "/configurations/qr-codes", icon: QrCode, requires: { resource: "qr_campaigns", action: "read" } },
      { id: "config-payment-plans", label: "Payment Plans", href: "/configurations/payment-plans", icon: Wallet, developerOnly: true, requires: { resource: "projects", action: "read" } },
      { id: "config-document-templates", label: "Document Templates", href: "/configurations/document-templates", icon: FileText, developerOnly: true, requires: { resource: "payments", action: "read" } },
      { id: "config-distribution", label: "Lead Distribution", href: "/configurations/distribution", icon: Zap, requires: { resource: "settings", action: "update" } },
      { id: "config-channel-partners", label: "Channel Partners", href: "/configurations/channel-partners", icon: Handshake, requires: { resource: "channel_partners", action: "read" } },
    ],
  },
];
